export default __webpack_public_path__ + "static/timeline-graphic-0c947e1dc4a147d92aa283a39accc41f.png";